import classnames from 'classnames';
import { useTranslation } from 'hooks/use-translation';
import React, { FC, useEffect, useMemo, useState } from 'react';
import styles from './styles.scss';

type IProps = {
	children?: Element;
}

const SafeguardSection: FC = (props: IProps) => {
	return (
		<section className={styles['ac-safeguard']}>
			<div className={styles['ac-safeguard-container']}>
				<h1>Tutoring without the hassle</h1>
				<p>From scheduling lessons to organising payment - everything is in one place.</p>
				<div className={styles['ac-safeguard-list']}>
					<div className={styles['ac-safeguard-item']}>
						<img src="https://web-data.zmlearn.com/image/oRkSnBWtYsB575YGrf8BNX/schedule.png" alt="" />
						<h1>Flexible Schedules</h1>
						<p>Arrange tutoring to fit your schedule. Reschedule as you need to ensure you never miss a lesson.</p>
					</div>
					<div className={styles['ac-safeguard-item']}>
						<img src="https://web-data.zmlearn.com/image/itLBpNLcuqk8VdMb5drUPz/tutor.png" alt="" />
						<h1>Tutor Replacement</h1>
						<p>We always find a suitable replacement in theshortest possible time.</p>
					</div>
					<div className={styles['ac-safeguard-item']}>
						<img src="https://web-data.zmlearn.com/image/8ac9jsYj86PYnm3q9YYGFM/quality.png" alt="" />
						<h1>Quality Control</h1>
						<p>All tutors go through an admission procedure and training.</p>
					</div>
				</div>
				<div className={styles['ac-safeguard-list2']}>
					<div className={styles['ac-safeguard-item']}>
						<img src="https://web-data.zmlearn.com/image/qqtkxTUTccdZz5Eva1yvbn/payment.png" alt="" />
						<h1>Payment and Refund</h1>
						<p>All common payment methods are available and refund available within 14 days of payment.</p>
					</div>
					<div className={styles['ac-safeguard-item2']}>
						<img src="https://web-data.zmlearn.com/image/ssCunFYCtX9wSxK7Z7QGfD/security.png" alt="" />
						<h1>Security</h1>
						<p>All data and personal information is 100% secure with us.</p>
					</div>
				</div>
			</div>
		</section>
	);
}

export default SafeguardSection
